module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button-close",
    class: {
      disabled: _vm.noshow === true
    },
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": "media/global/btn_continue.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-title"
  }, [_vm._v(_vm._s(this.$store.state.items.buttons.closeButton))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20a303a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonClose.vue
// module id = 127
// module chunks = 0